"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackTippingModuleViewed = exports.trackSubmissionOfPayment = exports.trackFieldClick = exports.trackSubmitClick = exports.trackCustomAmountChangeEvent = exports.trackCustomAmountClick = exports.trackPresetAmountClick = exports.fireOnce = void 0;
const common_buoy_analytics_1 = require("@buoyhealth/common.buoy-analytics");
const category = "ba-tipping";
function fireOnce(callback, key) {
    window.SNOWPLOW_EVENTS = window.SNOWPLOW_EVENTS || {};
    // Ensure events are fired only once.
    if (!window.SNOWPLOW_EVENTS[key]) {
        callback();
        window.SNOWPLOW_EVENTS[key] = Date.now();
    }
}
exports.fireOnce = fireOnce;
const trackPresetAmountClick = (interviewToken, tipAmount, placement) => {
    (0, common_buoy_analytics_1.trackStructuredEvent)({
        action: "selected-preset-amount",
        category,
        label: interviewToken,
        property: placement,
        value: tipAmount,
    });
};
exports.trackPresetAmountClick = trackPresetAmountClick;
const trackCustomAmountClick = (interviewToken, placement) => {
    (0, common_buoy_analytics_1.trackStructuredEvent)({
        action: "clicked-into-other-amount",
        category,
        label: interviewToken,
        property: placement,
    });
};
exports.trackCustomAmountClick = trackCustomAmountClick;
const trackCustomAmountChangeEvent = (interviewToken, value, placement) => {
    (0, common_buoy_analytics_1.trackStructuredEvent)({
        action: "entered-custom-amount",
        category,
        label: interviewToken,
        property: placement,
        value,
    });
};
exports.trackCustomAmountChangeEvent = trackCustomAmountChangeEvent;
const trackSubmitClick = (interviewToken, tipAmount, placement) => {
    (0, common_buoy_analytics_1.trackStructuredEvent)({
        action: "clicked-submit",
        category,
        label: interviewToken,
        property: placement,
        value: tipAmount,
    });
};
exports.trackSubmitClick = trackSubmitClick;
const trackFieldClick = (interviewToken, fieldName) => {
    (0, common_buoy_analytics_1.trackStructuredEvent)({
        action: "checkout-form-field-click",
        category,
        label: interviewToken,
        property: fieldName,
    });
};
exports.trackFieldClick = trackFieldClick;
const trackSubmissionOfPayment = (interviewToken, tipAmount, placement) => {
    (0, common_buoy_analytics_1.trackStructuredEvent)({
        action: "submit-payment",
        category,
        label: interviewToken,
        property: placement,
        value: tipAmount,
    });
};
exports.trackSubmissionOfPayment = trackSubmissionOfPayment;
const trackTippingModuleViewed = (interviewToken, placement) => {
    const event = {
        action: "module-viewed",
        category,
        label: interviewToken,
        property: placement,
    };
    const key = `${event.category}:${event.action}`;
    fireOnce(() => (0, common_buoy_analytics_1.trackStructuredEvent)(event), key);
};
exports.trackTippingModuleViewed = trackTippingModuleViewed;
//# sourceMappingURL=analytics.js.map